import { Component, OnInit, Inject } from '@angular/core';
import { DomSanitizer } from "@angular/platform-browser";
import { ErrorStateMatcher, MAT_DIALOG_DATA, MatAccordion, MatDialogRef, MatSnackBar, MatStepper } from '@angular/material';
import { MessageInterface } from 'app/site-settings/models/message-banner.model';

@Component({
  selector: "cz-my-zone-login-banner",
  templateUrl: "./my-zone-login-banner.component.html",
  styleUrls: ["./my-zone-login-banner.component.scss"],
})
export class MyZoneLoginBannerComponent implements OnInit {
  public message: MessageInterface;
  constructor(
    public readonly sanitizer: DomSanitizer,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      message: MessageInterface;
    }
  ) {}

  public ngOnInit(): void {
    this.message = this.data.message;
  }

  public removeTags(str: string) {
    if (str === null || str === "") return false;
    else str = str.toString();

    // Regular expression to identify HTML tags in
    // the input string. Replacing the identified
    // HTML tag with a null string.
    return str.replace(/(<([^>]+)>)/gi, "");
  }
}
